import _typeof from "@babel/runtime/helpers/typeof";
import { Filters } from "../Constants/filters";
import { MIN_SEPERATOR, MAX_SEPERATOR, AMPERSAND_SEPERATOR, COMMA_SEPERATOR } from "../Constants/buyerIntent";
export var parseFilters = function parseFilters(filters) {
  if (_typeof(filters) !== 'object') {
    return {};
  }
  return Object.keys(filters).reduce(function (acc, filterKey) {
    var filterValue = filters[filterKey];
    switch (filterKey) {
      case Filters.bodyType:
      case Filters.make:
        acc[filterKey] = filters[filterKey] && filters[filterKey].split(COMMA_SEPERATOR);
        return acc;
      case Filters.year:
      case Filters.price:
      case Filters.emi:
        acc[filterKey] = filterValue.split(AMPERSAND_SEPERATOR).reduce(function (acc, value) {
          var minValue = value.split(MIN_SEPERATOR);
          if (minValue.length === 2) {
            acc.min = minValue[1];
            return acc;
          }
          var maxValue = value.split(MAX_SEPERATOR);
          if (maxValue.length === 2) {
            acc.max = maxValue[1];
            return acc;
          }
          return acc;
        }, {});
        return acc;
      default:
        return acc;
    }
  }, {});
};